import APIError from "./APIError";

class UpdatePasswordReply {
  error?: APIError;
}

export default UpdatePasswordReply;
